import React from "react";
import { useNavigate } from "react-router-dom";
import Editable from "@/components/cms/Editable";
import ImageUploader from "@/components/cms/ImageUploader";
import styles from './cafe.module.css';

export type HomeCafeProps = {
    title_top?: string;
    body_top?: string;
    cta_text_top?: string;
    cta_text_link_top?: string;
    image_url_top?: string;

    title_bot?: string;
    body_bot?: string;
    cta_text_bot?: string;
    cta_text_link_bot?: string;
    image_url_bot?: string;
}

export default function HomeCafe(props: HomeCafeProps) {
    const navigate = useNavigate();

    return (
        <div className={styles.container}>
            <div className={styles.container_inner}>

                <div className={styles.content_container}>
                    <div className={styles.image_container}>
                        <ImageUploader page="home" section="cafe_top" field="image_url" currentUrl={props.image_url_top || ''}>
                            <img src={props.image_url_top || `${process.env.PUBLIC_URL}/assets/home/home_cafe-hero2.png`} className={styles.image} alt="Bradley Street Cafe" />
                        </ImageUploader>
                    </div>

                    <div style={{flex: 1}}>
                        <div className={styles.top_text_container}>
                            <Editable page="home" section="cafe_top" field="title" value={props.title_top || ''}>
                                <div className={styles.title}>{props.title_top}</div>
                            </Editable>
                            <Editable page="home" section="cafe_top" field="body" value={props.body_top || ''}>
                                <div className={styles.body}>{props.body_top}</div>
                            </Editable>
                            <Editable page="home" section="cafe_top" field="cta_text" value={props.cta_text_top || ''}>
                                <div onClick={() => navigate(props.cta_text_link_top || '/')} className={styles.button}>{props.cta_text_top}</div>
                            </Editable>
                        </div>
                    </div>
                </div>

                <div className={styles.content_container} style={{marginTop: 60}}>
                    <div style={{flex: 1}}>
                        <div className={styles.bottom_text_container}>
                            <Editable page="home" section="cafe_bottom" field="title" value={props.title_bot || ''}>
                                <div className={styles.title}>{props.title_bot}</div>
                            </Editable>
                            <Editable page="home" section="cafe_bottom" field="body" value={props.body_bot || ''}>
                                <div className={styles.body}>{props.body_bot}</div>
                            </Editable>
                            <Editable page="home" section="cafe_bottom" field="cta_text" value={props.cta_text_bot || ''}>
                                <div onClick={() => navigate(props.cta_text_link_bot || '/')} className={styles.button}>{props.cta_text_bot}</div>
                            </Editable>
                        </div>
                    </div>

                    <div className={styles.image_container}>
                        <ImageUploader page="home" section="cafe_bottom" field="image_url" currentUrl={props.image_url_bot || ''}>
                            <img src={props.image_url_bot || `${process.env.PUBLIC_URL}/assets/home/home_cafe-hero1.png`} className={styles.image} alt="Bradley Street Coffee" />
                        </ImageUploader>
                    </div>
                </div>

            </div>
        </div>
    );
}
